<template>
    <div></div>
</template>
<script>
export default {
    created(){
        this.$router.push('./realmgmt');  //dummy 용
    }
}
</script>